import React from 'react'
import { Box, Button, Text } from 'grommet'
import { I18n } from 'galarm-config'
import TintedImage from './TintedImage'

const MissedAlarmsNotificationButton = ({ count, onClick }) => (
  <Button
    plain
    margin="small"
    pad="medium"
    onClick={onClick}
    style={{ overflow: 'visible' }}
    aria-label={I18n.t('viewingExpiredAlarms')}>
    <Box
      width="24px"
      height="24px"
      align="center"
      justify="center"
      style={{ position: 'relative', overflow: 'visible' }}>
      <TintedImage
        tintColor="white"
        src={require('galarm-res/img/web/hourglass_bottom.svg').default}
        style={{ width: 20, height: 20 }}
      />
      {count > 0 && (
        <Box
          background="status-critical"
          round="large"
          align="center"
          justify="center"
          pad={{ horizontal: 'xsmall' }}
          style={{
            position: 'absolute',
            top: -9,
            right: -14,
            minWidth: 20,
            height: 18,
            zIndex: 1
          }}>
          <Text color="white" size="xsmall" weight="bold">
            {count > 99 ? '99+' : count}
          </Text>
        </Box>
      )}
    </Box>
  </Button>
)

export default MissedAlarmsNotificationButton
